module.exports = __webpack_public_path__ + "c1ca7fa0.svg";